import { useForm } from "react-hook-form";
import { REQUIRED_FIELD } from "../../utils/constants";
import CustomModal from "../modal/CustomModal";
import { Grid, TextField } from "@mui/material";

export default function DeleteRegisterRecordConformation({ deleteRecord, ...props }) {
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const handleModalClose = () => {
    reset({
      deletedReason: ""
    })
    props.closeDeleteModel();
  }

  return (
    <>
      <CustomModal
        title="रेकर्ड हटाउनुहोस्।"
        onModalSubmit={handleSubmit((data) => {
          deleteRecord(data);
          reset({
            deletedReason: ""
          });
        })}
        showModal={props.showDeleteModal}
        onModalClose={handleModalClose}
      >
        <Grid container spacing={2} mt={1}>
          <TextField
            label="रेकर्ड हटाउनुको कारण"
            size="small"
            type="text"
            variant="outlined"
            name="deletedReason"
            fullWidth
            {...register("deletedReason", { required: true })}
          />
          {errors.deletedReason && <span className="error-message">{REQUIRED_FIELD}</span>}
        </Grid>
      </CustomModal>
    </>
  )
}